import { useEffect } from "react";
import { TextField, Grid, Box } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  setDialog,
  resetForm,
  Banner,
} from "../../../../app/slices/bannerSlice";
import { Controller, useForm } from "react-hook-form";
import FilePondInput from "../../../../helpers/FilePondInput";
import { SelectProvince } from "../../../../components/Selectors/SelectProvince";
import { useState } from "react";
import {
  HiOutlineMegaphone,
  HiOutlineDocumentText,
  HiOutlineEye,
  HiOutlinePhoto,
} from "react-icons/hi2";
import FormDialog, {
  SectionCard,
  SwitchCard,
} from "../../../../components/FormDialog";

const BannerForm = () => {
  const _Banner = useSelector((state) => state.banner.banner);
  const _SearchBody = useSelector((state) => state.banner.searchBody);
  const _provinces = useSelector((state) => state.provinces.provinces.data);

  const [isAllProviances, setIsAllProviances] = useState(
    _Banner.form.province_ids?.length === 0 ? true : false
  );

  const isAdd = _Banner.form.id ? false : true;
  const {
    control,
    reset,
    handleSubmit,
    setValue,
    formState: { isDirty },
  } = useForm({
    defaultValues: _Banner.form,
  });

  const onSubmit = (data) => {
    const formData = new FormData();
    formData.append("url", data.url ?? "");
    if (!isAdd) formData.append("_method", "PUT");
    formData.append("title", data.title);
    if (!isAllProviances) {
      data.province_ids.forEach((id) => {
        formData.append("province_ids[]", id);
      });
    } else {
      formData.append("province_ids", "[]");
    }
    formData.append("is_hidden", data.is_hidden);
    if (data.logo && data.logo[0].name) formData.append("logo", data.logo[0]);
    if (isAdd) {
      dispatch(Banner.create(formData));
    } else {
      dispatch(Banner.update(data.id, formData, _SearchBody));
    }
  };
  useEffect(() => {
    reset({ ..._Banner.form });
  }, [_Banner.form, reset]);

  useEffect(() => {
    return () => {
      dispatch(resetForm());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const dispatch = useDispatch();

  const handlDialog = () => {
    dispatch(setDialog());
  };

  return (
    <FormDialog
      open={_Banner.dialog}
      onClose={handlDialog}
      icon={<HiOutlineMegaphone />}
      title={isAdd ? "إضافة اعلان" : "تعديل الاعلان"}
      subtitle={
        isAdd
          ? "أدخل معلومات الاعلان لإضافته"
          : "قم بتحديث معلومات الاعلان ثم احفظ التغييرات"
      }
      onSubmit={handleSubmit(onSubmit)}
      saveDisabled={!isDirty}
    >
      <SectionCard icon={<HiOutlineDocumentText />} title="معلومات الاعلان">
        <Grid item xs={12}>
          <Controller
            name="title"
            control={control}
            render={({ field }) => (
              <TextField
                required
                size="small"
                label="الاسم"
                fullWidth
                {...field}
              />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <Controller
            name="url"
            control={control}
            render={({ field }) => (
              <TextField size="small" label="الرابط" fullWidth {...field} />
            )}
          />
        </Grid>
      </SectionCard>

      <SectionCard icon={<HiOutlineEye />} title="الظهور">
        <Grid item xs={12} sm={6}>
          <Controller
            name="is_hidden"
            control={control}
            render={({ field }) => (
              <SwitchCard
                field={field}
                label="اخفاء الاعلان !"
                onChange={(e) => {
                  setValue("is_hidden", e.target.checked);
                }}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <SwitchCard
            field={{ value: isAllProviances }}
            label="كل المحافظات"
            onChange={(e) => {
              setIsAllProviances(e.target.checked);
              setValue(
                "province_ids",
                e.target.checked ? [] : _Banner.form.province_ids,
                { shouldDirty: true }
              );
            }}
          />
        </Grid>
        {isAllProviances ? null : (
          <Grid item xs={12}>
            <Controller
              name="province_ids"
              control={control}
              render={({ field }) => (
                <SelectProvince
                  multiple
                  onChange={(e, newValue) => {
                    var ids = newValue.map((x) => x.id);
                    setValue("province_ids", newValue ? ids : [], {
                      shouldDirty: true,
                    });
                  }}
                  value={_provinces?.filter((x) =>
                    field.value?.includes(x.id)
                  )}
                />
              )}
            />
          </Grid>
        )}
      </SectionCard>

      <SectionCard icon={<HiOutlinePhoto />} title="الصورة">
        <Grid item xs={12}>
          <Controller
            name="logo"
            control={control}
            render={({ field }) => (
              <Box>
                <FilePondInput field={field} required={isAdd} />
              </Box>
            )}
          />
        </Grid>
      </SectionCard>
    </FormDialog>
  );
};

export default BannerForm;
